/*
 * Apart from `lookup-history.ts`, which imports `node:crypto`, so that the
 * free and Pro table in `pro-offer.ts` can be read by a browser bundle.
 * `lookup-history.ts` re-exports it.
 */

/**
 * How many lookups a reader keeps, for how long, and how many one page shows.
 *
 * **The free cap was five until September 2026.** Five is small enough that a
 * reader turns history on, fills it in one sitting and watches their first
 * lookup fall off the end before the feature has shown them what it is for. A
 * hundred covers a week of ordinary reading. Pro went from a thousand to five
 * thousand in the same change.
 *
 * **Both memberships page at fifty.** The free page was five, which matched a
 * cap of five exactly and would be twenty pages over a hundred.
 *
 * **The Pro limit is also the ranking ceiling.** `HistoryRanking` reads up to
 * this many aggregates to score a saved list, and raising it raises what that
 * read costs. `docs/lookup-history.md` has the figures under "Ranking reads".
 * @param pro - Whether the reader holds Pro 专业.
 * @returns The cap, the retention window in days, and one page's size.
 */
export function historyLimits(pro: boolean): {
  limit: number;
  days: number;
  pageSize: number;
} {
  return pro
    ? { limit: 5000, days: 365, pageSize: 50 }
    : { limit: 100, days: 30, pageSize: 50 };
}
